import React from "react";
import clsx from "clsx";

const ContactOrbs = ({ scale }: { isActive: boolean; scale: number }) => {
  return (
    <div className={clsx("absolute z-0 pointer-events-none inset-0")}>
      <div
        className={`w-screen h-screen max-w-screen-lg mx-auto  transform-gpu origin-center transition-transform duration-500`}
        style={{ transform: `scale(${scale})` }}
      >
        {/* Top Left */}
        <div
          className="
          orb
          z-10
          top-24 left-1
          md:top-24 md:left-12
          w-20 h-20
          md:w-44 md:h-44

        "
        />
        {/* Top Right */}
        <div
          className="
          orb
          z-20
          top-40 right-20
          md:top-16 md:-right-8
          w-14 h-14
          md:w-32 md:h-32
        "
        />
        {/* Bottom Right */}
        <div
          className="
          orb
          z-30
          -bottom-5 -right-10
          md:bottom-3 md:right-3
          w-64 h-64
          md:!w-96 md:!h-96
        "
        />
      </div>
    </div>
  );
};

export default ContactOrbs;
